module.exports = __webpack_public_path__ + "static/media/Sarah S.5606e671.jpg";